var CELL_WIDTH = 150;
var CELL_HEIGHT = 90;
var CELL_GAP = 6;
var CellModalType;
(function (CellModalType) {
    CellModalType["WebView"] = "webView";
    CellModalType["LineChart"] = "lineChart";
    CellModalType["BarChart"] = "barChart";
    CellModalType["StackedBarChart"] = "stackedBarChart";
    CellModalType["PieChart"] = "pieChart";
})(CellModalType || (CellModalType = {}));

var CellDataTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CELL_WIDTH: CELL_WIDTH,
    CELL_HEIGHT: CELL_HEIGHT,
    CELL_GAP: CELL_GAP,
    get CellModalType () { return CellModalType; }
});

export { CellDataTypes as C, CELL_WIDTH as a, CELL_HEIGHT as b, CELL_GAP as c, CellModalType as d };
//# sourceMappingURL=CellDataTypes-1348df0a.js.map
